/* Blusafe Australia — R1 Wireless Remote interactive manual data.
   Rendered by au-manual-engine.js (see sections/au-r1-remote-manual.liquid).
   Guide content: September 2026 source manual. Illustrations: au-manual-r1-*.webp. */
window.R1_REMOTE_MANUAL_DATA = {
  "manual": {
    "title": "R1 Wireless Remote Setup, Pairing and Troubleshooting Manual",
    "product_family": "R1 Wireless Remote",
    "manual_version": "V2026.1",
    "source_edition": "September 2026 source manual",
    "primary_app": "TTLock",
    "install_time_estimate": "5–10 minutes",
    "lead": "Learn the two buttons and the status light, pair your R1 remote fob with your lock through the TTLock app, check its battery and records, delete it, replace the CR2032 cell and fix the most common pairing problems — without opening the PDF.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "compatible_apps": {
      "TTLock (recommended)": {
        "android": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
        "ios": "https://apps.apple.com/app/ttlock/id1033046018"
      }
    },
    "critical_warnings": [
      "Add your Blusafe TTLock lock to the app first — the remote pairs through the lock's Remote menu.",
      "Stand within 5 metres of the lock while pairing.",
      "Choose a validity type (Timed, Permanent or Recurring) and a name before pairing.",
      "Long-press the lock key until the red light flashes quickly — that is pairing mode.",
      "Short-press for everyday use; long presses are only for pairing."
    ]
  },
  "guides": [
    {
      "handle": "r1-01",
      "title": "Buttons and the status light",
      "category": "Preparation",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Understand the functions of the unlock and lock buttons on the R1 wireless remote fob and interpret the indicator light status signals.",
      "images": [
        {
          "src": "au-manual-r1-01-1.webp",
          "alt": "Buttons and indicator lights — Button & Indicator Light Status"
        }
      ],
      "notes": [
        "Normal operation: The status light flashes simultaneously with each button press (unlock or lock).",
        "Low battery: The indicator light flashes slowly when unlocking or locking, signaling that the CR2032 battery needs replacement."
      ],
      "warnings": [
        "Do not attempt to disassemble the remote fob housing unless replacing the battery, as this may damage the internal circuitry."
      ],
      "tips": [],
      "steps": [
        "Short-press the unlock button to unlock the paired lock; observe the status light flashing simultaneously.",
        "Short-press the lock button to lock the paired lock; observe the status light flashing simultaneously.",
        "Monitor the indicator light behaviour during operation to identify normal or low battery status."
      ],
      "expected_result": "The remote fob responds immediately to button presses with visible indicator light feedback; slow flashing indicates low battery requiring replacement.",
      "common_mistakes": [
        "Confusing unlock and lock button functions - Pressing the wrong button may leave the door in an unintended state.",
        "Ignoring slow-flashing indicator light - Low battery may cause intermittent operation failure if not replaced promptly.",
        "Holding buttons instead of short-pressing - Long presses are only used during pairing mode, not normal operation."
      ]
    },
    {
      "handle": "r1-02",
      "title": "Pair the remote with your lock",
      "category": "App setup",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Connect the R1 wireless remote fob to a TTLock-compatible smart lock using the TTLock mobile app.",
      "images": [
        {
          "src": "au-manual-r1-02-1.webp",
          "alt": "Pair with the lock — Pairing with the Lock"
        }
      ],
      "notes": [],
      "warnings": [
        "Ensure the lock is powered and within Bluetooth range (typically within 5 metres) before starting the pairing process."
      ],
      "tips": [],
      "steps": [
        "Open the TTLock app on your smartphone and tap the lock you want to pair with the remote.",
        "Tap \"Remote\" in the lock management menu.",
        "Tap \"Add Remote\" to initiate the pairing wizard.",
        "Select the validity type (Timed / Permanent / Recurring), enter a name for the remote, then tap \"Next\".",
        "Tap \"R1\" from the device list.",
        "Long-press the locking key on the wireless remote fob until the red light flashes quickly, then release and tap \"Next\" in the app.",
        "Tap the \"+\" icon next to the displayed device name to confirm pairing."
      ],
      "expected_result": "The app displays \"Pairing succeeded\" and the remote fob can now lock and unlock the paired lock.",
      "common_mistakes": [
        "Not long-pressing the locking key long enough - The red light must flash quickly to enter pairing mode; brief presses will not work.",
        "Attempting pairing outside Bluetooth range - The remote and lock must be within close proximity during the pairing process.",
        "Skipping the validity type selection - All remotes require a validity configuration before pairing can proceed.",
        "Tapping the wrong device in the list - Ensure you select the correct remote if multiple devices are shown."
      ],
      "app_links": true
    },
    {
      "handle": "r1-03",
      "title": "Check battery, records and validity",
      "category": "Management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Access detailed information about the paired R1 remote fob including battery level, usage records, and validity settings.",
      "images": [
        {
          "src": "au-manual-r1-03-1.webp",
          "alt": "View remote information — View Remote Info"
        }
      ],
      "notes": [],
      "warnings": [],
      "tips": [],
      "steps": [
        "Open the TTLock app and navigate to the paired lock's management page.",
        "Tap \"Remote\" to view the list of paired remote devices.",
        "Tap the target remote device to open its detail page.",
        "Review the battery level indicator, validity period, and unlock/lock records.",
        "Optionally rename the device or adjust its validity period from this screen."
      ],
      "expected_result": "The remote info page displays current battery status, access history, and allows configuration changes.",
      "common_mistakes": [
        "Confusing multiple paired remotes - Verify the remote name before checking records to ensure you are viewing the correct device.",
        "Not monitoring battery level regularly - Low battery may cause unexpected operation failure; check periodically.",
        "Forgetting to update validity period for temporary users - Expired remotes will not function until validity is extended."
      ]
    },
    {
      "handle": "r1-04",
      "title": "Delete a remote",
      "category": "Management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Remove a paired R1 wireless remote fob from the lock's authorised device list using the TTLock app.",
      "images": [
        {
          "src": "au-manual-r1-04-1.webp",
          "alt": "Delete a remote fob — Delete Remote Fob"
        }
      ],
      "notes": [],
      "warnings": [
        "Deleting a remote fob permanently removes its access privileges; ensure you have alternative access methods before deletion."
      ],
      "tips": [],
      "steps": [
        "Open the TTLock app and navigate to the paired lock's management page.",
        "Tap \"Remote\" to view the list of paired remote devices.",
        "Tap the wireless remote device you want to delete.",
        "Tap \"Delete\" at the bottom of the device detail page.",
        "Confirm the deletion when prompted by the app."
      ],
      "expected_result": "The remote fob is removed from the paired device list and can no longer operate the lock.",
      "common_mistakes": [
        "Deleting the wrong remote device - Double-check the remote name before confirming deletion to avoid removing active devices.",
        "Not having backup access after deletion - Ensure other access methods (keys, app, codes) are functional before deleting the last remote.",
        "Attempting to delete while offline - The deletion command requires network connectivity to sync with the lock."
      ]
    },
    {
      "handle": "r1-05",
      "title": "Replace the CR2032 battery",
      "category": "Maintenance",
      "estimated_time": "5 minutes",
      "difficulty": "Medium",
      "summary": "Replace the CR2032 coin cell battery in the R1 wireless remote fob when the indicator shows low battery status.",
      "images": [
        {
          "src": "au-manual-r1-05-1.webp",
          "alt": "Replace the battery — Battery Replacement"
        }
      ],
      "notes": [],
      "warnings": [
        "Use only CR2032 lithium coin cells; other battery types may damage the circuit board or provide insufficient voltage."
      ],
      "tips": [],
      "steps": [
        "Pry open the side seam between the two housing halves carefully using a thin tool.",
        "Lift out the PCBA (printed circuit board assembly) from the housing.",
        "Remove the depleted CR2032 battery from the PCBA battery holder.",
        "Insert a new CR2032 battery, following the polarity markings on the battery holder.",
        "Place the PCBA back into position inside the housing.",
        "Refit the housing halves together, ensuring the side seam is fully closed."
      ],
      "expected_result": "The remote fob powers on with fresh battery; indicator light flashes normally when buttons are pressed.",
      "common_mistakes": [
        "Installing the battery with reversed polarity — follow the markings on the holder.",
        "Damaging the PCBA during removal - Handle the circuit board gently to avoid bending or breaking components.",
        "Not closing the housing completely - An incomplete seal may allow moisture ingress and cause corrosion.",
        "Using non-CR2032 batteries - Only CR2032 provides the correct voltage and physical dimensions for this device."
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "r1-wont-pair",
      "title": "Remote won't pair with the lock",
      "category": "App setup",
      "priority": "high",
      "explanation": "Pairing needs three things at once: the app on the Add Remote wizard for the right lock, the remote in pairing mode (red light flashing quickly after a long press of the lock key) and the remote within Bluetooth range of the lock. If any of these lapses, the remote never appears in the list.",
      "symptoms": [
        "The R1 never appears after you tap Next.",
        "The app says pairing failed.",
        "The red light stops flashing before the app finds the remote."
      ],
      "quick_checks": [
        "You opened the lock in the TTLock app, tapped Remote, then Add Remote.",
        "You chose a validity type and entered a name before tapping Next.",
        "You selected \"R1\" from the device list.",
        "You long-pressed the lock key until the red light flashed quickly, then released it.",
        "You are within 5 metres of the lock and the lock is powered."
      ],
      "likely_causes": [
        "The lock key was not held long enough to enter pairing mode.",
        "The remote or phone was out of Bluetooth range of the lock.",
        "The battery is low, so the remote drops out of pairing mode.",
        "The wrong device was tapped in the list."
      ],
      "fix_steps": [
        "Move next to the door with the lock powered and your phone's Bluetooth on.",
        "In the app open the lock, tap Remote, Add Remote, choose the validity type and name, tap Next and select R1.",
        "Long-press the lock key on the remote until the red light flashes quickly, release it, then tap Next in the app.",
        "Tap + next to the remote as soon as it appears.",
        "If it still fails, fit a fresh CR2032 battery and repeat."
      ],
      "related_guides": [
        "r1-01",
        "r1-02",
        "r1-05"
      ],
      "support_evidence": [
        "A short video of the red light while you long-press the lock key",
        "A screenshot of the Add Remote screen where it fails"
      ],
      "app_links": false
    },
    {
      "handle": "r1-not-responding",
      "title": "Remote flashes but the lock does not respond",
      "category": "Everyday use",
      "priority": "high",
      "explanation": "The status light shows the remote sent a command; it does not prove the lock received it. Range, a low battery, an expired validity period or a deleted pairing all stop the lock from acting.",
      "symptoms": [
        "The light flashes but nothing happens at the door.",
        "It works sometimes, usually when very close to the lock.",
        "It stopped working on a particular date."
      ],
      "quick_checks": [
        "You are within about 5 metres of the lock with no heavy obstructions.",
        "The light flashes quickly, not slowly (slow means low battery).",
        "The remote still appears under Remote for that lock in the app.",
        "Its validity period has not ended.",
        "The lock's own batteries are not low."
      ],
      "likely_causes": [
        "Out of range.",
        "Low CR2032 battery.",
        "Timed or Recurring validity has expired.",
        "The remote was deleted from the lock."
      ],
      "fix_steps": [
        "Stand closer to the lock and try again.",
        "If the light flashes slowly, replace the CR2032 battery.",
        "In the app open the lock, tap Remote, tap the remote and check its validity — extend it if it has expired.",
        "If the remote is missing from the list, pair it again."
      ],
      "related_guides": [
        "r1-02",
        "r1-03",
        "r1-05"
      ],
      "support_evidence": [
        "A short video of the light while you press each button",
        "A screenshot of the remote's detail page showing its validity"
      ],
      "app_links": false
    },
    {
      "handle": "r1-slow-flash",
      "title": "Status light flashes slowly",
      "category": "Maintenance",
      "priority": "medium",
      "explanation": "A slow flash when you lock or unlock is the low-battery signal. The remote may still work intermittently, but it will fail without warning until the CR2032 cell is replaced.",
      "symptoms": [
        "The light flashes slowly instead of quickly.",
        "The lock responds only some of the time."
      ],
      "quick_checks": [
        "Compare the flash speed with a fresh press — slow means low battery."
      ],
      "likely_causes": [
        "The CR2032 battery is nearly flat."
      ],
      "fix_steps": [
        "Open the housing at the side seam with a thin tool and lift out the circuit board.",
        "Remove the old CR2032 and fit a new one following the polarity markings on the holder.",
        "Refit the board and close the housing fully, then press a button — the light should flash quickly again."
      ],
      "related_guides": [
        "r1-01",
        "r1-05"
      ],
      "support_evidence": [
        "Battery age, and whether a fresh CR2032 has been tried"
      ],
      "app_links": false
    },
    {
      "handle": "r1-no-light",
      "title": "No light at all when I press a button",
      "category": "Maintenance",
      "priority": "medium",
      "explanation": "With no light the remote is not powered. Either the battery is flat, it was fitted the wrong way round, or the circuit board is not seated properly after a battery change.",
      "symptoms": [
        "Neither button produces a flash.",
        "The remote stopped working straight after a battery change."
      ],
      "quick_checks": [
        "A fresh CR2032 is fitted with the correct polarity.",
        "The circuit board is sitting fully in the housing and the seam is closed.",
        "The battery is a CR2032 and not a different size."
      ],
      "likely_causes": [
        "Flat battery.",
        "Battery fitted the wrong way round.",
        "Circuit board not seated after reassembly."
      ],
      "fix_steps": [
        "Open the housing and check the battery polarity against the markings on the holder.",
        "Fit a new CR2032 if the old one is more than a year old.",
        "Seat the circuit board fully and close the housing so the seam is flush.",
        "If there is still no light, contact Blusafe Australia."
      ],
      "related_guides": [
        "r1-05"
      ],
      "support_evidence": [
        "A photo of the open remote showing the battery and board",
        "Whether a fresh CR2032 has been tried"
      ],
      "app_links": false
    },
    {
      "handle": "r1-expired",
      "title": "Remote stopped working on a certain date",
      "category": "Management",
      "priority": "low",
      "explanation": "Remotes are added with a validity type. A Timed or Recurring remote is only accepted inside its period; once it ends the lock ignores it until the period is extended in the app.",
      "symptoms": [
        "The remote worked until a specific day or time.",
        "The light still flashes normally."
      ],
      "quick_checks": [
        "Open the remote in the app and read its validity period."
      ],
      "likely_causes": [
        "The validity period has ended."
      ],
      "fix_steps": [
        "In the app open the lock, tap Remote, then the remote.",
        "Adjust the validity period or change it to Permanent.",
        "Test at the door."
      ],
      "related_guides": [
        "r1-03"
      ],
      "support_evidence": [
        "A screenshot of the remote's detail page showing its validity"
      ],
      "app_links": false
    },
    {
      "handle": "r1-cant-delete",
      "title": "Cannot delete the remote",
      "category": "Management",
      "priority": "low",
      "explanation": "Deleting a remote sends a command to the lock, so the app needs a working connection — either Bluetooth at the door or a gateway. If you are away from the lock without a gateway the delete fails.",
      "symptoms": [
        "Delete fails with a connection or network error.",
        "The remote reappears after deletion."
      ],
      "quick_checks": [
        "You are at the door with Bluetooth on, or the lock has a gateway online.",
        "You confirmed the deletion prompt."
      ],
      "likely_causes": [
        "No Bluetooth or gateway connection to the lock."
      ],
      "fix_steps": [
        "Stand at the door with Bluetooth on, open the lock in the app, tap Remote, the remote, then Delete and confirm.",
        "If the lock has a gateway, check the gateway is online and retry."
      ],
      "related_guides": [
        "r1-04"
      ],
      "support_evidence": [
        "The error shown when deleting",
        "Whether the lock has a gateway"
      ],
      "app_links": false
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Remote won't pair",
      "subject": "R1 Wireless Remote - will not pair with my lock",
      "body": "Hi Blusafe team,\n\nMy R1 Wireless Remote will not pair with my lock. Here are my details:\n\nOrder number: \nLock the remote is being paired to: \nDoes the red light flash quickly when I long-press the lock key? (yes/no): \nDistance from the lock while pairing: \nHave I tried a fresh CR2032? (yes/no): \n\nI have attached:\n- A short video of the light while I long-press the lock key\n- A screenshot of the Add Remote screen where it fails\n\nThanks,\n[Your name]"
    },
    {
      "title": "Remote not operating the lock",
      "subject": "R1 Wireless Remote - lock does not respond",
      "body": "Hi Blusafe team,\n\nMy R1 Wireless Remote flashes but the lock does not respond. Here are my details:\n\nOrder number: \nLock the remote is paired to: \nDoes the light flash quickly or slowly?: \nValidity type and period shown in the app: \nDistance from the lock when it fails: \n\nI have attached:\n- A short video of the light while I press each button\n- A screenshot of the remote's detail page in the app\n\nThanks,\n[Your name]"
    }
  ],
  "support_evidence_default": [
    "Order number and which app you used (TTLock)",
    "Which lock the remote is paired to",
    "Battery age, and whether a fresh CR2032 has been tried",
    "A short video of the status light while you press each button",
    "A screenshot of the remote's detail page in the app"
  ],
  "search_index": [
    {
      "title": "R1 Wireless Remote Setup, Pairing and Troubleshooting Manual",
      "type": "manual",
      "category": "Overview",
      "anchor": "osp-top",
      "summary": "Learn the two buttons and the status light, pair your R1 remote fob with your lock through the TTLock app, check its battery and records, delete it, replace the CR2032 cell and fix the most common pairing problems — without opening the PDF.",
      "keywords": "r1 remote fob key fob wireless remote controller ttlock pair add remote cr2032 battery slow flash red light validity timed permanent recurring delete"
    },
    {
      "title": "Buttons and the status light",
      "type": "guide",
      "category": "Preparation",
      "anchor": "r1-01",
      "summary": "Understand the functions of the unlock and lock buttons on the R1 wireless remote fob and interpret the indicator light status signals.",
      "keywords": "Short-press the unlock button to unlock the paired lock; observe the status light flashing simultaneously. Short-press the lock button to lock the paired lock; observe the status light flashing simultaneously. Monitor the indicator light behaviour during operation to identify normal or low battery status. Normal operation: The status light flashes simultaneously with each button press (unlock or lock). Low battery: The indicator light flashes slowly when unlocking or locking, signaling that the CR2032 battery needs replacement. Do not attempt to disassemble the remote fob housing unless replacing the battery, as this may damage the internal circuitry. Confusing unlock and lock button functions - Pressing the wrong button may leave the door in an unintended state. Ignoring slow-flashing indicator light - Low battery may cause intermittent operation failure if not replaced promptly. Holding buttons instead of short-pressing - Long presses are only used during pairing mode, not normal operation."
    },
    {
      "title": "Pair the remote with your lock",
      "type": "guide",
      "category": "App setup",
      "anchor": "r1-02",
      "summary": "Connect the R1 wireless remote fob to a TTLock-compatible smart lock using the TTLock mobile app.",
      "keywords": "Open the TTLock app on your smartphone and tap the lock you want to pair with the remote. Tap \"Remote\" in the lock management menu. Tap \"Add Remote\" to initiate the pairing wizard. Select the validity type (Timed / Permanent / Recurring), enter a name for the remote, then tap \"Next\". Tap \"R1\" from the device list. Long-press the locking key on the wireless remote fob until the red light flashes quickly, then release and tap \"Next\" in the app. Tap the \"+\" icon next to the displayed device name to confirm pairing. Ensure the lock is powered and within Bluetooth range (typically within 5 metres) before starting the pairing process. Not long-pressing the locking key long enough - The red light must flash quickly to enter pairing mode; brief presses will not work. Attempting pairing outside Bluetooth range - The remote and lock must be within close proximity during the pairing process. Skipping the validity type selection - All remotes require a validity configuration before pairing can proceed. Tapping the wrong device in the list - Ensure you select the correct remote if multiple devices are shown."
    },
    {
      "title": "Check battery, records and validity",
      "type": "guide",
      "category": "Management",
      "anchor": "r1-03",
      "summary": "Access detailed information about the paired R1 remote fob including battery level, usage records, and validity settings.",
      "keywords": "Open the TTLock app and navigate to the paired lock's management page. Tap \"Remote\" to view the list of paired remote devices. Tap the target remote device to open its detail page. Review the battery level indicator, validity period, and unlock/lock records. Optionally rename the device or adjust its validity period from this screen. Confusing multiple paired remotes - Verify the remote name before checking records to ensure you are viewing the correct device. Not monitoring battery level regularly - Low battery may cause unexpected operation failure; check periodically. Forgetting to update validity period for temporary users - Expired remotes will not function until validity is extended."
    },
    {
      "title": "Delete a remote",
      "type": "guide",
      "category": "Management",
      "anchor": "r1-04",
      "summary": "Remove a paired R1 wireless remote fob from the lock's authorised device list using the TTLock app.",
      "keywords": "Open the TTLock app and navigate to the paired lock's management page. Tap \"Remote\" to view the list of paired remote devices. Tap the wireless remote device you want to delete. Tap \"Delete\" at the bottom of the device detail page. Confirm the deletion when prompted by the app. Deleting a remote fob permanently removes its access privileges; ensure you have alternative access methods before deletion. Deleting the wrong remote device - Double-check the remote name before confirming deletion to avoid removing active devices. Not having backup access after deletion - Ensure other access methods (keys, app, codes) are functional before deleting the last remote. Attempting to delete while offline - The deletion command requires network connectivity to sync with the lock."
    },
    {
      "title": "Replace the CR2032 battery",
      "type": "guide",
      "category": "Maintenance",
      "anchor": "r1-05",
      "summary": "Replace the CR2032 coin cell battery in the R1 wireless remote fob when the indicator shows low battery status.",
      "keywords": "Pry open the side seam between the two housing halves carefully using a thin tool. Lift out the PCBA (printed circuit board assembly) from the housing. Remove the depleted CR2032 battery from the PCBA battery holder. Insert a new CR2032 battery, following the polarity markings on the battery holder. Place the PCBA back into position inside the housing. Refit the housing halves together, ensuring the side seam is fully closed. Use only CR2032 lithium coin cells; other battery types may damage the circuit board or provide insufficient voltage. Installing the battery with reversed polarity — follow the markings on the holder. Damaging the PCBA during removal - Handle the circuit board gently to avoid bending or breaking components. Not closing the housing completely - An incomplete seal may allow moisture ingress and cause corrosion. Using non-CR2032 batteries - Only CR2032 provides the correct voltage and physical dimensions for this device."
    },
    {
      "title": "Remote won't pair with the lock",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "r1-wont-pair",
      "summary": "The R1 never appears after you tap Next.",
      "keywords": "The R1 never appears after you tap Next. The app says pairing failed. The red light stops flashing before the app finds the remote. The lock key was not held long enough to enter pairing mode. The remote or phone was out of Bluetooth range of the lock. The battery is low, so the remote drops out of pairing mode. The wrong device was tapped in the list. Move next to the door with the lock powered and your phone's Bluetooth on. In the app open the lock, tap Remote, Add Remote, choose the validity type and name, tap Next and select R1. Long-press the lock key on the remote until the red light flashes quickly, release it, then tap Next in the app. Tap + next to the remote as soon as it appears. If it still fails, fit a fresh CR2032 battery and repeat. Pairing needs three things at once: the app on the Add Remote wizard for the right lock, the remote in pairing mode (red light flashing quickly after a long press of the lock key) and the remote within Bluetooth range of the lock. If any of these lapses, the remote never appears in the list."
    },
    {
      "title": "Remote flashes but the lock does not respond",
      "type": "troubleshooting",
      "category": "Everyday use",
      "anchor": "r1-not-responding",
      "summary": "The light flashes but nothing happens at the door.",
      "keywords": "The light flashes but nothing happens at the door. It works sometimes, usually when very close to the lock. It stopped working on a particular date. Out of range. Low CR2032 battery. Timed or Recurring validity has expired. The remote was deleted from the lock. Stand closer to the lock and try again. If the light flashes slowly, replace the CR2032 battery. In the app open the lock, tap Remote, tap the remote and check its validity — extend it if it has expired. If the remote is missing from the list, pair it again. The status light shows the remote sent a command; it does not prove the lock received it. Range, a low battery, an expired validity period or a deleted pairing all stop the lock from acting."
    },
    {
      "title": "Status light flashes slowly",
      "type": "troubleshooting",
      "category": "Maintenance",
      "anchor": "r1-slow-flash",
      "summary": "The light flashes slowly instead of quickly.",
      "keywords": "The light flashes slowly instead of quickly. The lock responds only some of the time. The CR2032 battery is nearly flat. Open the housing at the side seam with a thin tool and lift out the circuit board. Remove the old CR2032 and fit a new one following the polarity markings on the holder. Refit the board and close the housing fully, then press a button — the light should flash quickly again. A slow flash when you lock or unlock is the low-battery signal. The remote may still work intermittently, but it will fail without warning until the CR2032 cell is replaced."
    },
    {
      "title": "No light at all when I press a button",
      "type": "troubleshooting",
      "category": "Maintenance",
      "anchor": "r1-no-light",
      "summary": "Neither button produces a flash.",
      "keywords": "Neither button produces a flash. The remote stopped working straight after a battery change. Flat battery. Battery fitted the wrong way round. Circuit board not seated after reassembly. Open the housing and check the battery polarity against the markings on the holder. Fit a new CR2032 if the old one is more than a year old. Seat the circuit board fully and close the housing so the seam is flush. If there is still no light, contact Blusafe Australia. With no light the remote is not powered. Either the battery is flat, it was fitted the wrong way round, or the circuit board is not seated properly after a battery change."
    },
    {
      "title": "Remote stopped working on a certain date",
      "type": "troubleshooting",
      "category": "Management",
      "anchor": "r1-expired",
      "summary": "The remote worked until a specific day or time.",
      "keywords": "The remote worked until a specific day or time. The light still flashes normally. The validity period has ended. In the app open the lock, tap Remote, then the remote. Adjust the validity period or change it to Permanent. Test at the door. Remotes are added with a validity type. A Timed or Recurring remote is only accepted inside its period; once it ends the lock ignores it until the period is extended in the app."
    },
    {
      "title": "Cannot delete the remote",
      "type": "troubleshooting",
      "category": "Management",
      "anchor": "r1-cant-delete",
      "summary": "Delete fails with a connection or network error.",
      "keywords": "Delete fails with a connection or network error. The remote reappears after deletion. No Bluetooth or gateway connection to the lock. Stand at the door with Bluetooth on, open the lock in the app, tap Remote, the remote, then Delete and confirm. If the lock has a gateway, check the gateway is online and retry. Deleting a remote sends a command to the lock, so the app needs a working connection — either Bluetooth at the door or a gateway. If you are away from the lock without a gateway the delete fails."
    }
  ],
  "support_email": ""
};
